import { Flex, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const Loading = () => {
  return (
    <Flex style={{ width: '100vw', height: '100vh' }} justify="center" align="center" gap="small">
      <Spin indicator={<LoadingOutlined spin />} />
      <FormattedMessage id="loading" />
    </Flex>
  );
};

export default Loading;
